import Swiper from "swiper";
import { A11y, Autoplay, EffectFade, Pagination } from "swiper/modules";
import "@styles/components/slider.css";

export default {
  init: () => {
    document.querySelectorAll(".media-slider").forEach((el) => {
      const container = el.querySelector(".swiper");
      const sliderPagination = el.querySelector(".slider-pagination");
      const asMultipleVideos = container.querySelectorAll(".media-item.as-video").length > 1;

      const opts = {
        modules: [A11y, Autoplay, EffectFade, Pagination],
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        loop: true,
        speed: 1000,
      };

      if (!asMultipleVideos) {
        opts.autoplay = {
          delay: 4000,
          pauseOnMouseEnter: true,
        };
      }

      if (sliderPagination) {
        opts.pagination = {
          el: sliderPagination,
          clickable: true,
        };
      }

      const swiper = new Swiper(container, opts);

      if (asMultipleVideos) {
        container.querySelectorAll(".media-item.as-video video").forEach((video) => {
          video.loop = false;
          video.addEventListener("ended", () => {
            swiper.slideNext();
          });
        });

        swiper.on("slideChange", () => {
          const activeSlide = swiper.slides[swiper.activeIndex];
          activeSlide.querySelector("video").play();
        });
      } else {
        swiper.autoplay.stop();
      }

      const start = () => {
        if (asMultipleVideos) {
          const activeSlide = swiper.slides[swiper.activeIndex];
          activeSlide.querySelector("video").play();
        } else {
          swiper.autoplay.start();
        }
      };

      const observer = new IntersectionObserver(
        ([e]) => {
          if (e.isIntersecting) {
            start();
            observer.disconnect();
          }
        },
        {
          threshold: [0.7],
        },
      );

      observer.observe(el);
    });

    document.querySelectorAll(".media-block").forEach((el) => {
      const asMultipleVideos = el.querySelectorAll(".media-item.as-video").length > 1;

      if (!asMultipleVideos) {
        el.querySelectorAll("video").forEach((video) => {
          const observer = new IntersectionObserver(
            async ([e]) => {
              if (e.isIntersecting) {
                try {
                  await video.play();
                } catch (err) {
                  console.error(err);
                }
                observer.disconnect();
              }
            },
            {
              threshold: [0.7],
            },
          );

          observer.observe(el);
        });
      }
    });
  },
};
